<template>
  <div class="min-h-full flex flex-col bg-gray-100">
    <ul class="flex text-xl bg-gray-200 text-center">
      <li>
        <router-link
          :to="{ name: 'dashboard-links' }"
          class="block py-6 px-12 hover:text-blue-400"
          active-class="bg-gray-100"
        >
          <icon-home title="Dashboard" class="app-icon text-2xl" />
          Existing Links
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'create-link' }"
          class="block py-6 px-12 hover:text-blue-400"
          active-class="bg-gray-100"
        >
          <icon-plus-box class="app-icon text-2xl mr-1" />
          Create new link
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'start-link-from-template' }"
          class="block py-6 px-12 hover:text-blue-400"
          active-class="bg-gray-100"
        >
          <icon-plus-box-multiple class="app-icon text-2xl mr-1" />
          Create new link from template
        </router-link>
      </li>
    </ul>

    <div
      v-if="fetchingCompanies || fetchingSegments"
      class="text-center text-blue-400 my-8"
    >
      <base-loading class="block text-3xl" />
      Loading
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      fetchingCompanies: (state) => state.company.fetchingList,
      fetchingSegments: (state) => state.company.segment.fetchingList,
    }),
  },
};
</script>

<style lang="scss" scoped>
.app-icon {
  position: relative;
  top: 0.17em;
}
</style>
